import { createStructuredSelector } from 'reselect';
import { bool, func, shape } from 'prop-types';
import { yesBankMinKyc, kycStaticData } from './actions';
import { isLoading, select_ybl_min_kyc } from '../PayBalance/selectors';


const YblMinKycPropTypes = {
  isLoadingStatus: bool.isRequired,
  onYesBankMinKyc: func.isRequired,
  onKycStaticData: func.isRequired,
  location: shape({}).isRequired,
  YblMinKycSuccess: shape({}).isRequired,
  KycStaticData: shape({}).isRequired,
};

const YblMinKycmapDispatchToProps = (dispatch) => ({
  onYesBankMinKyc: (payload) => dispatch(yesBankMinKyc(payload)),
  onKycStaticData: () => dispatch(kycStaticData()),
});

const YblMinKycmapStateToProps = createStructuredSelector({
  YblMinKycSuccess: select_ybl_min_kyc('yblMinKyc'),
  KycStaticData: select_ybl_min_kyc('kycStaticData'),
  isLoadingStatus: isLoading(),
});

export { YblMinKycPropTypes, YblMinKycmapStateToProps, YblMinKycmapDispatchToProps };



// WEBPACK FOOTER //
// client/containers/YblMinKyc/YblMinKycDatahandler.js